<script>
export default {
  name: 'SupplierSelect',
}
</script>
<template>
  <customer-all-select
    v-bind="$attrs"
    v-on="$listeners"
    :supplier="true"
  ></customer-all-select>
</template>

<style scoped lang="scss">

</style>


